(function ( $ ) {

    $.fn.slideTo = function() {
    	var $that = $(this);

        return $(this).each(function(){
            var $target = $($(this).data('carousel')),
            	index = $(this).data('slide-to');

            $(this).click(function(){
            	if (!$(this).is('.active')) {
					        $that.removeClass('active');
            		  $(this).addClass('active');
            		  $target.slick('slickGoTo',index);
            	}
            });
        });
    };

}( jQuery ));

$(function(){
  	if ($('.js-product-crsl').length) {
  		$('.js-product-crsl').slick({
  			arrows : false,
  			fade : true,
        cssEase : 'cubic-bezier(0.540, 0.115, 0.230, 1)',
  		});
  	}

    if ($('.js-home-crsl').length) {
      $('.js-home-crsl').slick({
        arrows : false,
        fade : false,
        autoplay : true,
        autoplaySpeed: 4000,
        dots: true,
        cssEase : 'cubic-bezier(0.540, 0.115, 0.230, 1)',
      });
    }

    if ($('.js-products-crsl-4').length) {
        $('.js-products-crsl-4').slick({
            infinite: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            prevArrow: '<button class="crsl-control prev"><i class="icon-arrow-left"></button>',
            nextArrow: '<button class="crsl-control next"><i class="icon-arrow-right"></button>',
            cssEase : 'cubic-bezier(0.540, 0.115, 0.230, 1)',
            responsive: [
                {
                  breakpoint: 960,
                  settings: {
                    slidesToShow: 3,
                  }
                },
                {
                  breakpoint: 540,
                  settings: {
                    adaptiveHeight: true,
                    slidesToShow: 2,
                  }
                }
              ]
        });
    }

    if ($('.js-config-crsl').length) {
        $('.js-config-crsl').slick({
            infinite: false,
            slidesToShow: 4,
            slidesToScroll: 1,
            prevArrow: '<button class="crsl-control prev"><i class="icon-arrow-left"></button>',
            nextArrow: '<button class="crsl-control next"><i class="icon-arrow-right"></button>',
            cssEase : 'cubic-bezier(0.540, 0.115, 0.230, 1)',
            responsive: [
                {
                  breakpoint: 960,
                  settings: {
                    slidesToShow: 3,
                  }
                },
                {
                  breakpoint: 540,
                  settings: {
                    adaptiveHeight: true,
                    slidesToShow: 2,
                  }
                }
              ]
        });
    }

    if ($('.js-products-crsl-3').length) {
        $('.js-products-crsl-3').slick({
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            prevArrow: '<button class="crsl-control prev"><i class="icon-arrow-left"></button>',
            nextArrow: '<button class="crsl-control next"><i class="icon-arrow-right"></button>',
            cssEase : 'cubic-bezier(0.540, 0.115, 0.230, 1)',
            responsive: [
                {
                  breakpoint: 540,
                  settings: {
                    adaptiveHeight: true,
                    slidesToShow: 2,
                  }
                }
              ]
        });
    }

	if ($('.js-slide-to').length) {
		$('.js-slide-to').slideTo();
	}
});